module.exports = __webpack_public_path__ + "static/media/Kiosk-Screen7.4903ecd6.png";